import React from 'react'

export default function Popups() {
  return (
    <>
      <h1>Popups</h1>
      <p><span className='tag-grey bold'>.popup</span> class creates a stylized popup card container  </p>
      <p className='italic'>This requires the .js file of this library to function properly</p>

      <h2>Code:</h2>
      <p> the popup-trigger class is required for which ever element will trigger the popup</p>
      <p>The <span className='tag-grey bold'>data-modalid</span> attribute needs to be the same as the id of the target modal</p>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;div class="popup-trigger" data-modalId="popup1"&gt;trigger Popup&lt;/div&gt;<br/>
            &lt;div class="popup-overlay" id="popup1"&gt;<br/>
              &lt;div class="popup"&gt;<br/>
                &lt;div class="popup-title"&gt;<br/>
                &lt;span class="close-popup" data-modalId="popup1"&gt;&lt;/span&gt;
                hhh
                &lt;/div&gt;<br/>
                &lt;div class="popup-body"&gt;<br/>
                    ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
                &lt;/div&gt;<br/>
                &lt;div class="popup-footer"&gt;
                    hhh
                &lt;/div&gt;<br/>
         &lt;/div&gt;<br/>
        &lt;/div&gt;
        </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
      <div className="popup-trigger" id='bbb' data-modalid="popup1">trigger Popup</div>
        <div className="popup-overlay" id="popup1">
            <div className="popup">
                <div className="popup-title">
                <span className="close-popup" data-modalid="popup1"></span>
                hhh
                </div>
                <div className="popup-body">
                    ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
                </div>
                <div className="popup-footer">
                    hhh
                </div>
         </div>
        </div>
      </div>
    </>
  )
}
